import { render, staticRenderFns } from "./AnsButton.vue?vue&type=template&id=7e28c54c&scoped=true"
import script from "./AnsButton.vue?vue&type=script&lang=js"
export * from "./AnsButton.vue?vue&type=script&lang=js"
import style0 from "./AnsButton.vue?vue&type=style&index=0&id=7e28c54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e28c54c",
  null
  
)

export default component.exports